import { faScaleBalanced } from '@fortawesome/pro-regular-svg-icons'

import { TextColors, TypographyStyles } from '@/styles'
import { Icon, Separator, Text } from '@/ui'

import { CalculationRow } from '../estimate-breakdown-v3/shared/calculation-row'
import { centsToEstimateAmount } from '../utils'
import type { StateBreakdownData } from './stateBreakdownData'

export const StateTaxesSection = ({
  data,
  quarter,
}: {
  data: StateBreakdownData
  quarter: string | undefined
}) => (
  <>
    <div className="flex items-center mb-4">
      <Text variant={TypographyStyles.H2} className="flex items-center">
        <Icon icon={faScaleBalanced} className="mr-2" />
        Taxes
      </Text>
    </div>

    <Text className="w-full lg:w-8/12 mb-6" color={TextColors.MUTED}>
      Based on your {data.state} taxable income and {data.state} tax rates, this
      is what we estimate you&apos;ll owe there for the year.
    </Text>

    <CalculationRow
      left={<Text>Projected annual {data.state} tax</Text>}
      right={
        <Text variant={TypographyStyles.H3}>
          {centsToEstimateAmount(data.annualLiabilityInCents)}
        </Text>
      }
    />

    {quarter && (
      <>
        <CalculationRow
          left={<Text>Percentage due this quarter</Text>}
          right={
            <Text variant={TypographyStyles.H3} textAlign="right">
              {Number(quarter) * 25}%
            </Text>
          }
        />
        <Text color={TextColors.MUTED} className="w-full md:w-2/3 italic">
          {Number(quarter) * 25}% means your total due through Q{quarter}, not
          this quarter&apos;s share — an earlier quarter that went unpaid rolls
          forward into this one.
        </Text>
      </>
    )}

    {data.ytdDueInCents !== null && (
      <>
        <Separator />
        <CalculationRow
          left={
            <Text variant={TypographyStyles.H3}>
              Q{quarter} YTD {data.state} taxes due
            </Text>
          }
          right={
            <Text variant={TypographyStyles.H3} textAlign="right">
              {centsToEstimateAmount(data.ytdDueInCents)}
            </Text>
          }
        />
      </>
    )}
  </>
)
